module Client.Admin.ResetPassword.ResetMFA

open Shared
open Client
open Illy.SafeStack.Client
open Fable.React

type Model = 
    {
        UserId: UserId 
        GeneralError: string option
        Saving: bool
    }

type Msg = 
    | ApiError of ApiError
    | SaveResult of unit
    | CloseOverlay  
    | SaveClicked 

type Event = 
    | CloseOverlay 
    | ApiError of ApiError 
    | SaveSuccessful of notification: string 

let init userId = 
    {
        UserId = userId 
        GeneralError = None
        Saving = false
    }, []

let update msg model = 
    match msg with 
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event 
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event 
    | SaveClicked -> 
        {model with Saving = true},
        Api.mfaCall<IMfaApi,_,_,_> (fun api -> api.resetAppKey) model.UserId SaveResult Msg.ApiError
        |> SideEffect.Cmd
    | SaveResult _ -> 
        { model with Saving = false }, "User MFA token was reset successfully." |> Event.SaveSuccessful |> SideEffect.Event

let view model dispatch = 
    jQueryUI.modal "Reset the User's MFA Token" 50 Msg.CloseOverlay dispatch (Some 800) [
        yield jQueryUI.illy_info [
            str "Are you sure you want to reset the MFA token for this user? The user will be promped to scan a new QR Code the next time they log in."
        ]
        yield UI.renderError model.GeneralError
        yield! UI.saveControls (Some "Reset Token") false model.Saving SaveClicked Msg.CloseOverlay dispatch
    ]